
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gID37j3_45oqxREz3wHi3aY1vvz27adfiIo46j7bqGLWLEMeta } from "/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index40CQ61EFeHMHrz8WcDlYtEppVho3m4ClBMjgKR0EoKkMeta } from "/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search_n6czTmyXqcxYGTd8iR7Y2j_45__45u3aj0Ad2sGnEVkp2YMeta } from "/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexS1jq6Z7uq2cZUl9mbl2ZIo7IopwbtfqSJqVdpx0708cMeta } from "/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93oyQEYl4wWa_QHX_45nDLgex2TPiA3Wl1r2g_45desGEPy2gMeta } from "/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexgL1X8yvlJs38aZi_iWvfNfrwjLjFGqDFtdKN4e0UXs8Meta } from "/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93tBDbcPOEff9QQ1Y0zaAP4bKVhT2ruNOXhdtWqzPeMcYMeta } from "/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index3pchc_4510vMBUmPx99mbrP3bCh2Vk06MEGGaUvfxONIMMeta } from "/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93mCcWud8aU5AV1D9yT1Fh256VIxdXTmCKFKzHFBcGGDUMeta } from "/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indextvAvp9p0v4WHxUrq8CklUsxS2wrl2NtfVx3dwJN_45PwYMeta } from "/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexPhrhIdIfgepHHd3dK9ZJeRTRLAQCirWFa6uWELwTlcQMeta } from "/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexgL1X8yvlJs38aZi_iWvfNfrwjLjFGqDFtdKN4e0UXs8Meta || {},
    component: () => import("/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index3pchc_4510vMBUmPx99mbrP3bCh2Vk06MEGGaUvfxONIMMeta || {},
    component: () => import("/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indextvAvp9p0v4WHxUrq8CklUsxS2wrl2NtfVx3dwJN_45PwYMeta || {},
    component: () => import("/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexPhrhIdIfgepHHd3dK9ZJeRTRLAQCirWFa6uWELwTlcQMeta || {},
    component: () => import("/codebuild/output/src923105447/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]